import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ModuleLibrary from "./ModuleLibrary";
import ModuleInstances from "./ModuleInstances";
import PageBuilder from "./PageBuilder";
import FindSection from "./FindSection";
import NavigationManager from "@/components/admin/NavigationManager";
import { CustomStaticPages } from "@/components/admin/CustomStaticPages";
import CmsFieldMapOverview from "@/components/admin/CmsFieldMapOverview";
import CmsFieldGroupsManager from "@/components/admin/CmsFieldGroupsManager";
import PropertyFormLayout from "@/components/admin/PropertyFormLayout";
import PropertyArticlesAdminTab from "@/components/admin/PropertyArticlesAdminTab";
import { Package, Layout, Navigation, File, Layers, Sparkles, Table as TableIcon, LayoutList, Newspaper, FolderTree } from "lucide-react";

export default function CMSTab() {
  const [activeSubTab, setActiveSubTab] = useState("pages");

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Content Management System</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Manage your website content, pages, and navigation
        </p>
      </div>

      <Tabs value={activeSubTab} onValueChange={setActiveSubTab} className="w-full">
        {/* Compact pill layout: wraps to a second row on narrow viewports
            instead of squashing icon + label into 60px columns. */}
        <TabsList className="flex flex-wrap gap-1 h-auto w-full justify-start bg-muted/50 p-1">
          <TabsTrigger value="pages" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto">
            <Layout className="h-3.5 w-3.5" />
            Pages
          </TabsTrigger>
          <TabsTrigger value="custom-pages" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto">
            <File className="h-3.5 w-3.5" />
            Custom
          </TabsTrigger>
          <TabsTrigger value="modules" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto" data-testid="tab-module-library">
            <Package className="h-3.5 w-3.5" />
            Modules
          </TabsTrigger>
          <TabsTrigger value="instances" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto" data-testid="tab-module-instances">
            <Layers className="h-3.5 w-3.5" />
            Instances
          </TabsTrigger>
          <TabsTrigger value="find" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto" data-testid="tab-find">
            <Sparkles className="h-3.5 w-3.5" />
            Find
          </TabsTrigger>
          <TabsTrigger value="navigation" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto">
            <Navigation className="h-3.5 w-3.5" />
            Nav
          </TabsTrigger>
          <TabsTrigger value="cms-field-map" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto" data-testid="tab-cms-field-map">
            <TableIcon className="h-3.5 w-3.5" />
            Fields
          </TabsTrigger>
          <TabsTrigger value="cms-field-groups" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto" data-testid="tab-cms-field-groups">
            <FolderTree className="h-3.5 w-3.5" />
            Field Groups
          </TabsTrigger>
          <TabsTrigger value="property-form" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto" data-testid="tab-property-form-layout">
            <LayoutList className="h-3.5 w-3.5" />
            Property Form
          </TabsTrigger>
          <TabsTrigger value="articles" className="flex items-center gap-1.5 text-xs px-2.5 py-1.5 h-auto" data-testid="tab-articles">
            <Newspaper className="h-3.5 w-3.5" />
            Articles
          </TabsTrigger>
        </TabsList>

        <TabsContent value="pages" className="mt-6">
          <PageBuilder />
        </TabsContent>

        <TabsContent value="custom-pages" className="mt-6">
          <CustomStaticPages />
        </TabsContent>

        <TabsContent value="modules" className="mt-6">
          <ModuleLibrary />
        </TabsContent>

        <TabsContent value="instances" className="mt-6">
          <ModuleInstances />
        </TabsContent>

        <TabsContent value="find" className="mt-6">
          <FindSection />
        </TabsContent>

        <TabsContent value="navigation" className="mt-6">
          <NavigationManager />
        </TabsContent>

        <TabsContent value="cms-field-map" className="mt-6">
          <CmsFieldMapOverview />
        </TabsContent>

        <TabsContent value="cms-field-groups" className="mt-6">
          <CmsFieldGroupsManager />
        </TabsContent>

        <TabsContent value="property-form" className="mt-6">
          <PropertyFormLayout />
        </TabsContent>

        <TabsContent value="articles" className="mt-6">
          <PropertyArticlesAdminTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
